const educationDataArray = [
  {
    id: 1,
    school: "Palmer College of Chiropractic",
    program: "Doctor of Chiropractic, Chiropractic",
    time: "2016-2020",
    other: ""
  },
  {
    id: 2,
    school: "San José State University",
    program: "Bachelor of Science, Kinesiology",
    time: "2011-2016",
    other: "Pre-Physical Therapy Club"
  }
]

const experienceDataArray = [
  {
    id: 1,
    title: "South Bay Rehab and Performance",
    position: "Chiropractor & Founder/Owner",
    time: "2021-Present"
  },
  {
    id: 2,
    title: "Private Corporation",
    position: "Wellness Team Member",
    time: "2021-Present"
  },
  {
    id: 3,
    title: "Various Clinics",
    position: "Intern & Assistant",
    time: "2020"
  },
  {
    id: 4,
    title: "Stanford Health Care",
    position: "Physical Therapy Volunteer",
    time: "2014-2015"
  }
]

const certificationDataArray = [
  {
    id: 1,
    title: "PRI Postural Respiration"
  },
  {
    id: 2,
    title: "DNS A"
  },
  {
    id: 3,
    title: "FRC"
  },
  {
    id: 4,
    title: "FR Spine and Upper Limb"
  },
  {
    id: 5,
    title: "FAKTR Tools"
  }
]

export { educationDataArray, experienceDataArray, certificationDataArray }